export default __webpack_public_path__ + "static/media/results_longago.f85f3132.png";